import { GET_CITIES_ERROR, GET_CITIES_LOADING, GET_CITIES_SUCCESS, GET_COUNTRIES_ERROR, GET_COUNTRIES_LOADING, GET_COUNTRIES_SUCCESS, GET_STATES_ERROR, GET_STATES_LOADING, GET_STATES_SUCCESS } from "./actionTypes";

const initialState = {
    countries: {
        loading: false,
        data: null,
        error: null
    },
    states: {
        loading: false,
        data: null,
        error: null
    },
    cities: {
        loading: false,
        data: null,
        error: null
    },
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_COUNTRIES_LOADING:
            return { ...state, countries: { ...state.countries, loading: true, data: null, error: null } };
        case GET_COUNTRIES_SUCCESS:
            return { ...state, countries: { ...state.countries, loading: false, data: action.payload, error: null } };
        case GET_COUNTRIES_ERROR:
            return { ...state, countries: { ...state.countries, loading: false, data: null, error: action.payload } };

        case GET_STATES_LOADING:
            return { ...state, states: { ...state.states, loading: true, data: null, error: null } };
        case GET_STATES_SUCCESS:
            return { ...state, states: { ...state.states, loading: false, data: action.payload, error: null } };
        case GET_STATES_ERROR:
            return { ...state, states: { ...state.states, loading: false, data: null, error: action.payload } };

        case GET_CITIES_LOADING:
            return { ...state, cities: { ...state.cities, loading: true, data: null, error: null } };
        case GET_CITIES_SUCCESS:
            return { ...state, cities: { ...state.cities, loading: false, data: action.payload, error: null } };
        case GET_CITIES_ERROR:
            return { ...state, cities: { ...state.cities, loading: false, data: null, error: action.payload } };

        default:
            return state;
    }
};

export default reducer;
